import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const redirectToLastVisited = (to, from, next) => {
  next({
    path: (store.state.steps[parseInt(to.name, 10) - 2] || store.state.steps[0])
      .completed
      ? store.getters.getLastVisitedStepNumber
      : ''
  })
}

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: {
        name: '1'
      }
    },
    {
      path: '/pick-dataset',
      name: '1',
      components: {
        default() {
          return import('./views/content/PickDataset')
        },
        editor() {
          return import('./views/editor/PickDataset')
        }
      }
    },
    {
      path: '/push-data',
      name: '2',
      components: {
        default() {
          return import('./views/content/PushData')
        },
        editor() {
          return import('./views/editor/PushData')
        }
      },
      beforeEnter(to, from, next) {
        redirectToLastVisited(to, from, next)
      }
    },
    {
      path: '/set-relevance',
      name: '3',
      components: {
        default() {
          return import('./views/content/SetRelevance')
        },
        editor() {
          return import('./views/editor/SetRelevance')
        }
      },
      beforeEnter(to, from, next) {
        redirectToLastVisited(to, from, next)
      }
    },
    {
      path: '/build-ui',
      name: '4',
      components: {
        default() {
          return import('./views/content/BuildUI')
        },
        editor() {
          return import('./views/editor/BuildUI')
        },
        codesandbox() {
          return import('@/partials/CodeSandbox')
        }
      },
      beforeEnter(to, from, next) {
        redirectToLastVisited(to, from, next)
      }
    },
    {
      path: '/success',
      name: '5',
      components: {
        default() {
          return import('./views/content/Success')
        },
        editor() {
          return import('./views/editor/Success')
        }
      },
      beforeEnter(to, from, next) {
        redirectToLastVisited(to, from, next)
      }
    }
  ]
})

router.afterEach(to => {
  store.commit('setStepAsVisited', { step: parseInt(to.name, 10) - 1 })
})

export default router
